'use client';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useEffect, useRef, useState } from 'react';
import { Text, Container } from '@weareconceptstudio/core';

//* Styles
import GetMuramoneyStyle from './style';

//* Lottie
import muramoney from '../../../../public/lottie/muramoney.json';

//* Component
import LottieAnimation from '@/components/LottieAnimation';

const GetMuramoney = ({ title, description }) => {
	//! Ref
	const scrollTriggerRef = useRef();

	//! State
	const [lottiePlay, setLottiePlay] = useState(false);

	useEffect(() => {
		ScrollTrigger.create({
			start: 'top center',
			end: 'top top',
			// markers: true,
			trigger: '.lottie-muramoney',
			onEnter: () => {
				setLottiePlay(true);
			},
		});

		return () => {
			if (scrollTriggerRef.current) scrollTriggerRef.current.kill();
		};
	}, []);

	return (
		<GetMuramoneyStyle>
			<Container
				isSection
				row>
				<div className='wrapper-cashback col-6 col-m-12'>
					<Text
						className={'h2 uppercase'}
						tag={'h2'}>
						{title}
					</Text>

					<Text className={'p3'}>{description}</Text>
				</div>

				<div className='muramoney-dram col-6 col-m-12'>
					<LottieAnimation
						className={'lottie-muramoney'}
						loop={true}
						autoplay={lottiePlay}
						isPlay={lottiePlay}
						animData={muramoney}
					/>
					{/* <div className='wrapper-muramoney-animation'>
						<div className='father-div'>
							<div className='cat'>
								<div className='background-gradient' />
							</div>
							<div className='dog'>
								<div className='background-gradient' />
							</div>
						</div>
					</div> */}
				</div>
			</Container>
		</GetMuramoneyStyle>
	);
};

export default GetMuramoney;
